import ListGroup from 'react-bootstrap/ListGroup';
import Tooltip from 'react-bootstrap/Tooltip';
import { NavLink, useLocation } from 'react-router-dom';
import { SiteNavOption, PageNavOption, PageActionOption } from '../LeftSidebar/NavOptions';

interface SidebarListProps {
    options: PageNavOption[] | SiteNavOption[] | PageActionOption[];
    selectedOption?: PageNavOption | SiteNavOption | PageActionOption;
    onClick?: (opt: any) => void;
    className?: string;
}

const SidebarList = (props: SidebarListProps) => {
    const { options, selectedOption, onClick, className } = props;
    const location = useLocation();
    return (
        <ListGroup style={{ borderRight: 0 }} id={'page-left-side-bar'} className={className || ''}>
            {options.map((opt: any, i: number) => {
                const isActive = opt.path
                    ? location?.pathname?.includes(opt?.path)
                    : opt?.name === selectedOption?.name;
                return (
                    <ListGroup.Item
                        key={i}
                        className={'menu-item'}
                        active={isActive}
                        data-testid={opt.name}
                        onClick={() => onClick && onClick(opt)}
                    >
                        <Tooltip id={opt.name} placement="right" title={opt.name} color={'#B2BEB5'}>
                            {opt.path ? (
                                <NavLink to={opt?.path} className={'nav-link'}>
                                    <img
                                        src={isActive ? opt.activeIcon : opt.icon}
                                        alt={opt.name}
                                        className={'main-left-sidebar-icon icon'}
                                    />
                                </NavLink>
                            ) : (
                                <img
                                    src={isActive ? opt.activeIcon : opt.icon}
                                    alt={opt.name}
                                    className={'main-left-sidebar-icon icon'}
                                />
                            )}
                        </Tooltip>
                    </ListGroup.Item>
                );
            })}
        </ListGroup>
    );
};

export default SidebarList;
